module.exports = __webpack_public_path__ + "media/images/btn_new_tag-bc3f0b8b672e6832989bf98ede7d1307.gif";